// Stellarium Web - Copyright (c) 2022 - Stellarium Labs SRL
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'

Vue.use(Vuex)

const createStore = () => {
  var pluginsModules = {}
  for (const i in Vue.SWPlugins) {
    const plugin = Vue.SWPlugins[i]
    if (plugin.storeModule) {
      console.log('Register store module for plugin: ' + plugin.name)
      pluginsModules[plugin.name] = plugin.storeModule
    }
  }

  return new Vuex.Store({
    modules: pluginsModules,

    state: {
      stel: null,
      initComplete: false,

      showNavigationDrawer: false,
      showDataCreditsDialog: false,
      showViewSettingsDialog: false,
      showPlanetsVisibilityDialog: false,
      // [guanxing patch] M-SW9：太阳系视图（orrery）全屏对话框开关。
      showSolarSystemDialog: false,
      // [guanxing patch] M-SW25：出生时刻（带时区偏移的 iso，App.vue openBirthFate
      // 写入）。太阳系对话框打开时用它定位 ?t=（星命弹窗「你出生时的太阳系」行）。
      solarSystemBirthIso: '',
      // [guanxing patch] M-QZ：七政四余开关（图层菜单）；引擎侧由
      // swh.setQzsyEnabled 驱动（四余图层显隐 + 七政传统名标志）。
      showQizhengSiyu: false,
      // [guanxing patch] M-SW38：导出星图预览对话框开关（底栏「导出星图」
      // 按钮置 true；截图与状态保存/恢复逻辑在 star-map-export-dialog.vue）。
      showStarMapExportDialog: false,
      selectedObject: undefined,

      // [guanxing patch] M-SW53：星命弹窗跳转上下文——{ type:'xingci'|'lord',
      // name, objId }。星次/星君行跳转时由 App.vue 写入，知识栏据此把内容
      // 换成星次块/星君+宿块；用户切换选中/关卡片时清除（见
      // selected-object-info.vue）。null = 无星命上下文（普通选中）。
      fateView: null,

      showSidePanel: false,

      showObservingPanelTabsButtons: true,
      showSelectedInfoButtons: true,
      showFPS: false,
      showEquatorialJ2000GridButton: false,

      // 当前星空文化（'western' | 'chinese'，M-SW3b）；引擎侧由
      // $stel.core.skycultures.current_id 驱动，这里只做 UI 状态镜像。
      skycultureId: 'western',

      // [guanxing patch] UI 空闲自动隐藏（M-SW3d）：鼠标/触摸静止 3s 且无打开的
      // 菜单/对话框时置 true，底栏与天体信息卡随之淡出；任何活动立即恢复。
      uiIdle: false,

      // [guanxing patch] 落地页隐藏底栏（M-SW21c，用户反馈「首页是隐藏 下面的
      // 横栏」）：出生天象落地页挂载期间整条隐藏底栏（gui.vue bottom-bar 的
      // ui-hidden 复用），离开落地页（提交/跳过）由 App.vue watcher 置回 false。
      landingActive: false,

      fullscreen: false,
      nightmode: false,
      wasmSupport: true,

      autoDetectedLocation: {
        short_name: 'Unknown',
        country: 'Unknown',
        street_address: '',
        lat: 0,
        lng: 0,
        alt: 0,
        accuracy: 5000
      },

      currentLocation: {
        // [guanxing patch] 默认观测点北京（AGENTS.md §4：定位失败不猜测，默认
        // 39.9042N 116.4074E）；浏览器定位成功后由 setAutoDetectedLocation 覆盖。
        short_name: '北京',
        country: '中国',
        street_address: '',
        lat: 39.9042,
        lng: 116.4074,
        alt: 43,
        accuracy: 1
      },

      useAutoLocation: true
    },
    mutations: {
      replaceStelWebEngine (state, newTree) {
        // mutate StelWebEngine state
        state.stel = newTree
      },
      toggleBool (state, varName) {
        _.set(state, varName, !_.get(state, varName))
      },
      setValue (state, { varName, newValue }) {
        _.set(state, varName, newValue)
      },
      setAutoDetectedLocation (state, newValue) {
        state.autoDetectedLocation = { ...newValue }
        if (state.useAutoLocation) {
          state.currentLocation = { ...newValue }
        }
      },
      setUseAutoLocation (state, newValue) {
        state.useAutoLocation = newValue
        if (newValue) {
          state.currentLocation = { ...state.autoDetectedLocation }
        }
      },
      setCurrentLocation (state, newValue) {
        state.useAutoLocation = false
        state.currentLocation = { ...newValue }
      },
      setSelectedObject (state, newValue) {
        state.selectedObject = newValue
      }
    }
  })
}

export default createStore
